var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 365,
    viewBox: "0 0 1440 365",
    width: 1440,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 164.724c162.103-98.282 447.959-238.6395 486-115.6399 43.044 139.1749-393.2064 427.9999-346.5 266.9999 42.5-146.5 270.29-100.629 283-91 16.5 12.5-25.5 101.5 63.5 101.5s179.5-382.4998 309.5-294.4998c130 87.9998 131.5 273.4998 303.5 283.9998s232-271.9998 194.5-283.9998-150.26 212.7678 44 264.4998c48.5 12.916 77 16.154 102.5 16.154",
    stroke: "#faf7f5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroLine);
export default __webpack_public_path__ + "static/media/hero-line.1143dc5f301eec15a8e64f85cc2fdc10.svg";
export { ForwardRef as ReactComponent };